export function isAdmin(user){
    return !!user.roles?.find((role) => role.name === 'admin')
}